import { Component } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Punto de entrada para participantes (Microsoft Entra ID).
 * Si el usuario ya está autenticado vía MSAL, redirige a la zona segura.
 */
@Component({
  selector: 'app-participantes',
  templateUrl: './participantes.component.html',
  styleUrls: ['./participantes.component.css']
})
export class ParticipantesComponent {

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigate(['/participantes/zonasegura'], { replaceUrl: true });
  }
}
